var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIa7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 195,
    viewBox: "0 0 332 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.231445,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint0_linear_492_655)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231445,
    y: 94.8833,
    width: 217.164,
    height: 99.1716,
    rx: 19,
    fill: "url(#paint1_linear_492_655)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 228.978,
    y: 94.8833,
    width: 102.791,
    height: 99.1716,
    rx: 19,
    fill: "url(#paint2_linear_492_655)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.604,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint3_linear_492_655)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 228.978,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint4_linear_492_655)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0898,
    y: 9.46582,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0898,
    y: 78.958,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "url(#paint5_linear_492_655)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 241.283,
    y: 78.958,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "url(#paint6_linear_492_655)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 126.91,
    y: 9.46582,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 241.283,
    y: 9.46582,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_655",
    x1: 51.627,
    y1: 0.0551758,
    x2: 51.627,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_492_655",
    x1: 108.814,
    y1: 94.8833,
    x2: 108.814,
    y2: 194.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_492_655",
    x1: 280.373,
    y1: 94.8833,
    x2: 280.373,
    y2: 194.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_492_655",
    x1: 166,
    y1: 0.0551758,
    x2: 166,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_492_655",
    x1: 280.373,
    y1: 0.0551758,
    x2: 280.373,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_492_655",
    x1: 39.6831,
    y1: 78.958,
    x2: 39.6831,
    y2: 88.3685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_492_655",
    x1: 269.876,
    y1: 78.958,
    x2: 269.876,
    y2: 88.3685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIa7);
export default __webpack_public_path__ + "static/media/product-ia-7.f3c8295432b5b9023ba6a94067f402ab.svg";
export { ForwardRef as ReactComponent };